import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { BlockSettingsProps } from './types';
export const BlockContainerSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Layout')}
                name="layout"
                value={state.item.settings.layout || 'horizontal'}
                onChange={(e) => handleChangeSettings('layout', e.target.value)}
                margin="normal"
            >
                <MenuItem value="horizontal">{kedo.t('Horizontal')}</MenuItem>
                <MenuItem value="vertical">{kedo.t('Vertical')}</MenuItem>
            </TextField>
        </Box>
    );
};